import React from "react";

const WinnerListDetail = () => {
  return (
    <div className="WrapperArea">
      <div className="WrapperBox">
        <div className="Small-Wrapper">
          <div className="TitleBox Border">
            <h4 className="Title">
              Please enter below details to submit answer details
            </h4>
          </div>
          <div className="CommonForm">
            <div className="form-group">
              <label>Name of Student (Auto-fill)</label>
              <input type="text" className="form-control" placeholder="Ajay" />
            </div>
            <div className="form-group">
              <label>Challenge Title (Auto-fill)</label>
              <input
                type="text"
                className="form-control"
                placeholder="Title Name"
              />
            </div>
            <div className="form-group">
              <label>Deadline Date (Auto-fill)</label>
              <input
                type="text"
                className="form-control"
                placeholder="12/07/2024"
              />
            </div>
            <div className="form-group">
              <label>Submission Text</label>
              <textarea
                className="form-control"
                placeholder="Write here"
                rows={5}
                defaultValue={""}
              />
            </div>
            <div className="form-group">
              <div className="ViewFile">
                <span>
                  <img src="images/pdf.png" />
                </span>
                <p>
                  <label>View File</label>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WinnerListDetail;
